// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__axQMp","controls":"styles_controls__ovxlN","charLimit":"styles_charLimit__2mtlM","input":"styles_input__1R86k","send":"styles_send__373r1"};